export default __webpack_public_path__ + "static/media/admin_product_reports.55c34377.svg";